jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

    // 针对featured-product-2.liquid
    // document.querySelectorAll('div[data-product-featured]').forEach((div, index) => {
    //     // 给偶数位（从1开始计数）的元素设置
    //     if (index % 2 === 1) {
    //         div.classList.add('custom-flex-cloumn-reverse');
    //     }
    // });


});
